import React, { useState, useCallback, useRef, useEffect } from "react";
import "./Gallery.css";
import HamburgerMenu from "../../../Components/HamburgerMenu/HamburgerMenu";
import BackBtn from "../../../Components/BackBtn/BackBtn";
import BottomBar from "../../../Components/BottomBar/BottomBar";
import { useLocation } from "react-router-dom";
import QuickPinchZoom, { make3dTransformValue } from "react-quick-pinch-zoom";
import { LazyLoadImage } from "react-lazy-load-image-component";

export default function Gallery() {
  const location = useLocation();
  const { images } = location.state || [];
  const [showHamburgerMenu, setShowHamburgerMenu] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const imgRef = useRef();

  useEffect(() => {
    if (images && images.length > 0) {
      setSelectedImage(images[0].file);
    }
  }, [images]);

  const hamburgerMenuHandler = () => {
    setShowHamburgerMenu(true);
  };

  const hideMenuHandler = () => {
    setShowHamburgerMenu(false);
  };

  const handleThumbnailClick = (imageFile) => {
    setSelectedImage(imageFile);
  };

  const onUpdate = useCallback(({ x, y, scale }) => {
    const img = imgRef.current;
    if (img) {
      const value = make3dTransformValue({ x, y, scale });
      img.style.setProperty("transform", value);
    }
  }, []);

  return (
    <div className="gymBg bgContainer">
      <HamburgerMenu
        showHamburgerMenu={showHamburgerMenu}
        onHide={hideMenuHandler}
      />
      <div className="blurOverlay galleryContainer">
        <div className="pageWrapper galleryOverlay">
          <div className="pageHeader centeredFlex galleryHeader">
            <BackBtn />
            <img
              src="/images/ic_menu.svg"
              alt="menu"
              className="menuIcon"
              onClick={hamburgerMenuHandler}
            />
          </div>
          <div className="galleryContent scroll centeredFlex">
            <div className="mainZoomImageWrapper">
              {images && selectedImage && (
                <QuickPinchZoom onUpdate={onUpdate}>
                  <img
                    ref={imgRef}
                    src={selectedImage}
                    alt="Selected"
                    className="mainImageContainer"
                    style={{height: window.innerHeight * 0.55}}
                  />
                </QuickPinchZoom>
              )}
            </div>
            <div className="thumbnailsWrapper centeredFlex scroll">
              {images &&
                images.map((image, index) => (
                  <div key={index} className="thumbnailImgContainer">
                    <LazyLoadImage
                      width="100%"
                      height="100%"
                      src={image.file || "/images/bgLogo.svg"}
                      alt={`Thumbnail ${index}`}
                      effect="opacity"
                      placeholderSrc="/images/bgLogo.svg"
                      className="thumbnailImg"
                      style={{
                        borderRadius: "0.625rem",
                      }}
                      onError={({ target }) => {
                        target.onerror = null;
                        target.src = "/images/bgLogo.svg";
                      }}
                      onClick={() => handleThumbnailClick(image.file)}
                    />
                    {selectedImage === image.file && (
                      <div className="thumbnailDesign"></div>
                    )}
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
      <BottomBar />
    </div>
  );
}
